import React, { useState } from "react";
import classes from "./SectionTopUvPlayed.module.css";
import { useNavigate } from "react-router-dom";
import TopUvPlayedGamesModal from "./TopUvPlayedGamesModal";
import { useTranslation } from "react-i18next";

const SectionTopUvPlayed = ({ topUvPlayedGames }) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [modal, setModal] = useState(false);

  return (
    <>
      <section className={classes.section}>
        <div className={classes.bgGlowOne}></div>
        <div className={classes.bgGlowTwo}></div>
        <div className={classes.gridOverlay}></div>

        <div className={classes.container}>
          <div className={classes.leftContent}>
            <span className={classes.topTag}>{t("66")}</span>

            <h2 className={classes.heading}>
              {t("67")}
              <span className={classes.yearBadge}>{currentYear}</span>
            </h2>

            <p className={classes.description}>{t("68")}</p>

            <button
              className={classes.ctaButton}
              onClick={() => setModal(true)}
            >
              {t("69")}
            </button>
          </div>

          <div className={classes.rightContent}>
            <div className={classes.cardMain}>
              <div className={classes.cardTopRow}>
                <span className={classes.liveDot}></span>
                <span className={classes.cardLabel}>{t("70")}</span>
              </div>

              <div className={classes.statsWrap}>
                <div className={classes.statBox}>
                  <h3>{t("71")}</h3>
                  <p>{t("72")}</p>
                </div>

                <div
                  className={classes.statBox}
                  onClick={() =>
                    navigate("/game", {
                      state: {
                        game: topUvPlayedGames?.[0],
                      },
                    })
                  }
                >
                  <h3>{t("73")}</h3>
                  <p>{topUvPlayedGames?.[0]?.game_name}</p>
                </div>

                {/* <div className={classes.statBox}>
                <h3>Players</h3>
                <p>100K+</p>
              </div>

              <div className={classes.statBox}>
                <h3>Year</h3>
                <p>{currentYear}</p>
              </div> */}
              </div>
            </div>

            <div className={classes.floatingCircle}></div>
            <div className={classes.floatingLine}></div>
          </div>
        </div>
      </section>

      <TopUvPlayedGamesModal
        games={topUvPlayedGames}
        setModal={setModal}
        modal={modal}
      />
    </>
  );
};

export default SectionTopUvPlayed;
